import { render, staticRenderFns } from "./createMid.vue?vue&type=template&id=7fbe2f28&scoped=true"
import script from "./createMid.vue?vue&type=script&lang=js"
export * from "./createMid.vue?vue&type=script&lang=js"
import style0 from "./createMid.vue?vue&type=style&index=0&id=7fbe2f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbe2f28",
  null
  
)

export default component.exports